import React from "react"

import { iLink } from "./types"

const ExternalLink: React.FC<{ link: iLink; Icon?: any }> = ({
  link,
  Icon,
}) => {
  const characterLimit = link.title.length
  return (
    <a href={link.link} target="_blank">
      <div className="flex py-1 w-full items-start text-site-blue-dark hover:underline  transition duration-100">
        <p className="text-sm text-site-blue-dark flex item-center">
          {Icon && <span className="mr-2">{Icon}</span>}
          <span>
            {link.title.slice(0, characterLimit)}
            {link.title.length > characterLimit && "..."}
          </span>
        </p>
      </div>
    </a>
  )
}

export default ExternalLink
